<script lang="ts" setup>
import type { Link } from "@/modules/public/components/HomeNavigationLink";
import { mdiChevronDown } from "@mdi/js";
import { useTranslate } from "@/composables/use-translate";

const { t } = useTranslate();

const items: Link[] = [
  {
    name: "Veelgestelde vragen",
    to: "https://support.woordhelder.nl/hc/nl/categories/360000938119-Taalblobs",
  },
  {
    name: "Instructievideo's",
    to: "instructie",
  },
  {
    name: "Handleiding",
    to: `https://www.taalblobs.${t("extension")}/handleiding_taalblobs.pdf`,
  },
  {
    name: "Training",
    to: "trainingen",
  },
  {
    name: "Contact",
    to: "contact",
  },
];
</script>

<template>
  <li>
    <v-menu
      location="bottom"
      :open-on-hover="$vuetify.display.mdAndUp"
      open-on-click
    >
      <template v-slot:activator="{ props }">
        <v-btn
          :class="
            items?.some(({ to }) => $route.name === to)
              ? 'bg-grey-lighten-2'
              : ''
          "
          v-bind="props"
          :block="$vuetify.display.mdAndDown"
          class="font-weight-medium mr-1"
          variant="plain"
        >
          Ondersteuning <v-icon class="ml-1">{{ mdiChevronDown }}</v-icon>
        </v-btn>
      </template>

      <v-list nav density="compact" color="primary">
        <v-list-item
          v-for="({ to, name }, i) of items"
          :key="i"
          :href="to.includes('http') ? to : undefined"
          :to="to.includes('http') ? undefined : { name: to }"
          :target="to.includes('http') ? '_blank' : undefined"
        >
          <v-list-item-title class="px-2">{{ name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </li>
</template>
